import { jsx } from "react/jsx-runtime";
import { Grid } from "@elliemae/ds-grid";
import { DSControlledCheckbox } from "@elliemae/ds-form-checkbox";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { useCheckboxFieldUpdateLogic } from "./utils/fieldUpdateLogic";
const Checkbox = ({
  renderedField,
  schemaForm,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  disabled
}) => {
  const checkboxUpdateLogic = useCheckboxFieldUpdateLogic();
  return /* @__PURE__ */ jsx(
    Grid,
    {
      mt: "2px",
      gutter: "xs",
      height: "100%",
      wrap: "nowrap",
      alignItems: "center",
      justifyContent: "flex-start",
      span: ui.col_size ?? 2,
      cols: ["auto", "auto", "auto", "auto"],
      children: /* @__PURE__ */ jsx(
        DSFormLayoutBlockItem,
        {
          inputID: `epps-field-id-${name}`,
          label: "",
          required,
          feedbackMessage,
          children: /* @__PURE__ */ jsx(
            DSControlledCheckbox,
            {
              ...renderedField,
              checked: renderedField?.value ?? false,
              name,
              label,
              id: pathValue,
              onChange: checkboxUpdateLogic(renderedField, schemaForm),
              disabed: disabled
            }
          )
        }
      )
    }
  );
};
export {
  Checkbox
};
